import React, { Component } from 'react';

// Conf
import conf from './_core/_conf';

// Core
import Loader from './_core/components/Loader';
import Site from './_core/utils/Site';

// Project
import DataRouter from './components/Router';

import PrismicDOM from 'prismic-dom';

function linkResolver(input){
  console.log(input);
  return input.id;
}

function asHtml(field){

  return PrismicDOM.RichText.asHtml(field,linkResolver);

}


class Index extends Component {


  constructor(props){

      super(props);
  }

  render() {

    // Load the settings to get the manifest (JSON data to power the site)
    let settings = conf.get();

    return (

      <Loader wait={0} manifest={[{'name':'refs',src:'https://casswellbank.cdn.prismic.io/api/v2',type:'json',subset:'refs'}]} progress={()=>{return null}} loaded={

          ({refs})=>{
              if(!refs) return null;
             
             
              let master = refs.find(r=>(r.isMasterRef));

              return (
              <Loader wait={0} manifest={[{'name':'entries',src:`https://casswellbank.cdn.prismic.io/api/v2/documents/search?ref=${master.ref}`,type:'json',subset:'results',transformer: (entries) => {

          let transformed =  entries.map(entry => {

              let e = {...entry};

              switch(e.type){

                  case 'home':
                    e.uri = e.uid == 'home' ? '/' : `/${e.uid}/`;
                    e.projects = e.data.projects.map(p=>(p.project.id));
                    e.information = asHtml(e.data.information);
                    e.contact = asHtml(e.data.contact);
                    e.template = 'index';
                    break;
                  case 'projects':
                    e.uri = `/projects/${e.uid}/`;
                    e.template = 'default';
                    e.body = asHtml(e.data.body);
                    break;
                  default :
                  e.uri = `/${e.uid}/`;

              }

              if(e.data.hasOwnProperty('title')){
                e.title = e.data.title[0].text;
              }

              return e;

          })

          console.log('ENTRIES',transformed);
          return transformed;

      }}]} progress={()=>{return null}} loaded={

                  ({content})=>(
                  <Site>
                    <DataRouter />
                  </Site>
                  )

              }/>
              )

          }

      }/>

    )
    
    return (
      <Loader wait={0} manifest={[{'name':'entries',src:'/data/entries.json',type:'json'},{'name':'pixel',src:'/ui/img/pixel.png'}]} progress={()=>{return null}} loaded={

          ()=>(
          <Site>
            <DataRouter />
          </Site>
          )

      }/>
      
    );
  }
}



export default Index;



// WEBPACK FOOTER //
// ./src/js/index.js